export const kCalculatorTileType = "Calculator"
export const kV2CalculatorDGType = "DG.Calculator"  // component type in documents
export const kV2CalculatorDIType = "calculator"     // component type in plugin API
export const kCalculatorTileClass = "calculator"
